import { render } from "./GoodsList.vue?vue&type=template&id=593fd710"
import script from "./GoodsList.vue?vue&type=script&setup=true&lang=js"
export * from "./GoodsList.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/parts/GoodsList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "593fd710"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('593fd710', __exports__)) {
    console.log('reload')
    api.reload('593fd710', __exports__)
  }
  
  module.hot.accept("./GoodsList.vue?vue&type=template&id=593fd710", () => {
    console.log('re-render')
    api.rerender('593fd710', render)
  })

}


export default __exports__